export default __webpack_public_path__ + "static/media/Card-Latitude.d82a5dd6.png";